<template>
  <div class="" style="width:100%">
    <div class="card-box" v-for="item in list">
      <header class="card-name">
        {{item.name}}
      </header>
       <router-link tag="div" :to="{path:child.path,query:{url: child.url}}" v-for="child in item.children" style="text-align:center">
        <card :title="child.name">
          <div class="" slot="media">
             <img src="../../assets/3.png" style="width: 80%;" alt="" />
          </div>
        </card>
      </router-link>
    </div>
  </div>
</template>

<script>

import card from 'components/card.vue'

export default {
  data() {
    return {
      currentDate: new Date(),
      list:[]
    };
  },
   components:{
    card: card
  },
   methods: {
      request: function(){
         var vm = this
         vm.list = [
           {
              name:'基础档案',
              children:[
                {name:"基础参数设置",path:'/rzBaseParam', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzBaseParam/toRzBaseParamPage?moduleValue=base_param&rt=JTRx2s6Pny2AcZAi8hJQXf5yfarRH7bm'},
                {name:"收付类别管理",path:'/rzRecptpmt', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzRecptpmt/toRzRecptpmtPage?moduleValue=rzRecptpmt&rt=wTwrcwEjWiR55ARwsYfh54NAJNkTQbnG'},
                {name:"利率管理",path:'/rzRate',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzRate/toRzRatePage?moduleValue=rzRate&rt=T4xCcYKYSG3F66xJ3cYjhJhGfnGxDti5'},
                {name:"租赁设备管理",path:'/rzEqpt',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzEqpt/toRzEqptPage?moduleValue=rzEqpt&rt=4JjHiWinnRE7WjQnzz77sbkpck47y6xR'}
              ]
            },
            {
              name:'客户管理',
              children:[
                {name:"企业客户",path:'/crmEnterpriseclient',url:'http://pre.yx.imfbp.com/imfbp-crm-web/crmEnterpriseclient/toCrmEnterpriseclientPage?moduleValue=crm_enterpriseClient&rt=r4P3AZcXAtEC7hCPtKRKrB2A4AswJmFy'},
                {name:"个人客户",path:'/crmConsumerclient', url:'http://pre.yx.imfbp.com/imfbp-crm-web/crmConsumerclient/toCrmConsumerclientPage?moduleValue=crm_consumerClient&rt=dbpnMbzQHE3xRsXHsxKpjSEWKHDFmnpJ'},
                {name:"联系人",path:'/crmContacts', url:'http://pre.yx.imfbp.com/imfbp-crm-web/crmContacts/toCrmContactsPage?moduleValue=crm_contacts&rt=Fd4WYB7GGdmnYzRKwn86E2bFcQW3hDez'}
              ]
            },
            {
              name:'模板管理',
              children:[
                {name:"模板定义",path:'/templateDef',url:'http://pre.rz.imfbp.com/imfbp-rz-web/templateDef/toTemplateDefPage?moduleValue=tmpldef&rt=RrzWMnAyWnkih7iT4PGJwGDfJxPY558s'},
                {name:"模板生成规则",path:'/template', url:'http://pre.rz.imfbp.com/imfbp-rz-web/template/toTemplateNodeDefPage?moduleValue=tmplrule&rt=S2Rz8fDMEXzb3nEMR7XzdmajbpczCMHb'}
              ]
            },
            {
              name:'租前管理',
              children:[
                {name:"报价测算",path:'/rzPricecal',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPricecal/toRzPricecalPage?moduleValue=rzPricecal&rt=PN7bXdBmf2yBJAcSySEa43i3Z6yPhnwH'},
                {name:"立项申请",path:'/rzPrjapply',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPrjapply/toRzPrjapplyPage?moduleValue=rzPrjapply&rt=CJJxsarXfTkKDGXNWEr7PMr7SeANSaAh'},
                {name:"项目评审",path:'/rzPrjreview',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPrjreview/toRzPrjreviewPage?moduleValue=rzPrjreview&rt=dDbkibmyiKfx5mQ8P6X3TpJYhaE2s5bk'},
                {name:"项目合同",path:'/rzPrjcontr', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPrjcontr/toRzPrjcontrPage?moduleValue=rzPrjcontr&rt=EP7mkJPCcbmkCd2YnkQbRe5j5eKMmSct'}
              ]
            },
            {
              name:'租后管理',
              children:[
                {name:"收付计划表",path:'/rzPmtPlan',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPmtPlan/toRzPmtPlanPage?moduleValue=pmt_plan&rt=iBJ6WpeYWKXckCCC3kxWkPHMNwyk6M6c'},
                {name:"调息管理",path:'/rzAdjInt',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzAdjInt/toRzAdjIntPage?moduleValue=adj_int&rt=spirtE3X37kFesYbzCYpJFGDHTNE3WYS'},
                {name:"合同变更",path:'/rzPrjcontrChg',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPrjcontrChg/toRzPrjcontrChgPage?moduleValue=contr_adj&rt=iAsFWpFTsEGmnks2NpndXcBTXzhdcwrn'},
                {name:"租金计划变更",path:'/rzPlanChange', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPlanChange/toRzPlanChangePage?moduleValue=plan_change&rt=RmdMd3HWEFh37NFFtzkhkJtm4yWaJtKb'},
                {name:"逾期罚息",path:'/rzDefInterest', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzDefInterest/toRzDefInterestPage?moduleValue=def_interest&rt=2KcrnSkdpXmCC6z5Ht7yEH6sAi6ddh8D'},
                {name:"租赁物管理",path:'/rzPrjcontrEqptmngr', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzPrjcontrEqptmngr/toRzPrjcontrEqptmngrPage?moduleValue=prjcontr_eqptmngr&rt=2cxmYaH78zxynspTZT85x6xJap8KRwQp'},
                {name:"资产风险分类",path:'/rzAssetRiskclass', url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzAssetRiskclass/toRzAssetRiskclassPage?moduleValue=asset_riskclass&rt=bsW5xj3S2awEMy8MHYjbhhKDjzCQCFEP'}
              ]
            },
            {
              name:'报表',
              children:[
                {name:"项目进度查询",path:'/rzContrTallyProQuery',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzContrTallyProQuery/toRzContrTallyProQueryPage?moduleValue=rzContrTallyProQuery&rt=dtXhefSKFAJeSeanrznEyy8TYW5JdQZQ'},
                {name:"合同台账余额",path:'/rzContrTally',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzContrTally/toRzContrTallyBalancePage?moduleValue=contr_tally_balance&rt=4j4kde7EcwXmxa6SBrDrfbW33tpbm52d'},
                {name:"合同台账明细",path:'/rzContrTallyDetail',url:'http://pre.rz.imfbp.com/imfbp-rz-web/rzContrTallyDetail/toRzContrTallyDetailPage?moduleValue=toRzContrTallyDetailPage&rt=sj6NdaxDZhDSxGiDihDtkCbQyfZNJ8bc'}
              ]
            }
          ]

      },
      opentab: function(child){
        var path = child.path;
        console.log('path:'+path);
        this.$router.push({path:path,query:{url: child.url}});

      }
    },

    created: function(){
      this.request()
    }
}
</script>

<style>
  /*.card-box{
    margin:50px!important;
    box-shadow: 1.5px 1.5px 2px 2px #ccc;
    padding: 20px 40px 40px 40px;
    border-radius:3px;
  }*/

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 50%;
    display: block;
    margin: 0 auto;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
 No newline at end of file



// WEBPACK FOOTER //
// index.vue?74e44fcb